var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#25282C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#2B2F32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 27.5H16.25C14.1822 27.5 12.5 25.8177 12.5 23.75V16.25C12.5 14.1822 14.1822 12.5 16.25 12.5H23.75C25.8177 12.5 27.5 14.1822 27.5 16.25V23.75C27.5 25.8177 25.8177 27.5 23.75 27.5ZM16.25 13.75C14.8715 13.75 13.75 14.8715 13.75 16.25V23.75C13.75 25.1285 14.8715 26.25 16.25 26.25H23.75C25.1285 26.25 26.25 25.1285 26.25 23.75V16.25C26.25 14.8715 25.1285 13.75 23.75 13.75H16.25Z",
    fill: "#F4FD84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.625C18.0012 23.625 16.375 21.9988 16.375 20C16.375 18.0012 18.0012 16.375 20 16.375C21.9988 16.375 23.625 18.0012 23.625 20C23.625 21.9988 21.9988 23.625 20 23.625ZM20 17.568C18.659 17.568 17.568 18.659 17.568 20C17.568 21.341 18.659 22.432 20 22.432C21.341 22.432 22.432 21.341 22.432 20C22.432 18.659 21.341 17.568 20 17.568Z",
    fill: "#F4FD84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 16.75C24.6083 16.75 25 16.3582 25 15.875C25 15.3918 24.6083 15 24.125 15C23.6418 15 23.25 15.3918 23.25 15.875C23.25 16.3582 23.6418 16.75 24.125 16.75Z",
    fill: "#F4FD84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fcd675f01e33624a386e75e5c4f0c5b8.svg";
export { ForwardRef as ReactComponent };